/*!
 * Attaches Performance Navigation Timing data to Snowplow events v4.7.0 (https://docs.snowplow.io/)
 * Copyright 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * Licensed under BSD-3-Clause
 */

var PERFORMANCE_NAVIGATION_TIMING_SCHEMA = 'iglu:org.w3/PerformanceNavigationTiming/jsonschema/1-0-0';

/**
 * Creates a context from the PerformanceNavigationTiming object
 *
 * @returns object PerformanceNavigationTiming context
 */
function getPerformanceNavigationTimingContext() {
    var performanceAlias = window.performance || window.mozPerformance || window.msPerformance || window.webkitPerformance || {};
    if (performanceAlias.getEntriesByType) {
        var performanceNavigationTiming = performanceAlias.getEntriesByType('navigation')[0];
        if (!performanceNavigationTiming) {
            return [];
        }
        return constructNavigationTimingContext(performanceNavigationTiming);
    }
    return [];
}
function constructNavigationTimingContext(performanceNavigationTimingInstance) {
    var performanceNavigationKeys = [
        'entryType',
        'duration',
        'nextHopProtocol',
        'workerStart',
        'redirectStart',
        'redirectEnd',
        'fetchStart',
        'domainLookupStart',
        'domainLookupEnd',
        'connectStart',
        'secureConnectionStart',
        'connectEnd',
        'requestStart',
        'responseStart',
        'responseEnd',
        'transferSize',
        'encodedBodySize',
        'decodedBodySize',
        'serverTiming',
        'unloadEventStart',
        'unloadEventEnd',
        'domInteractive',
        'domContentLoadedEventStart',
        'domContentLoadedEventEnd',
        'domComplete',
        'loadEventStart',
        'loadEventEnd',
        'type',
        'redirectCount',
        'activationStart',
        'deliveryType',
    ];
    var performanceContextData = performanceNavigationKeys.reduce(function (accum, key) {
        var performanceValue = performanceNavigationTimingInstance[key];
        if (key === 'serverTiming' && Array.isArray(performanceValue)) {
            accum[key] = performanceValue.length
                ? performanceValue.map(function (_a) {
                    var description = _a.description, duration = _a.duration, name = _a.name;
                    return ({
                        description: description,
                        duration: duration,
                        name: name,
                    });
                })
                : undefined;
        }
        else if (performanceValue) {
            accum[key] = performanceValue;
        }
        return accum;
    }, {});
    return [
        {
            schema: PERFORMANCE_NAVIGATION_TIMING_SCHEMA,
            data: performanceContextData,
        },
    ];
}

var navigationTimingEntry;
/**
 * Adds Performance Navigation Timing context to events
 *
 * @remarks
 * May not be fully populated when initial Page View fires
 * Often a good idea to take the latest performance timing context
 * for a given page view id when analyzing in the warehouse
 */
function PerformanceNavigationTimingPlugin() {
    return {
        activateBrowserPlugin: function () {
            /* Setup a PerformanceObserver to allow caching of a completed navigation timing entry. We don't need to query the API after that. */
            if (typeof PerformanceObserver !== 'undefined') {
                var perfObserver = new PerformanceObserver(function (observedEntries) {
                    var observedNavigationTiming = observedEntries.getEntries()[0];
                    /* We mark the entry as final by the measurement of loadEventEnd which is the final in the processing model  */
                    if (observedNavigationTiming.loadEventEnd > 0) {
                        navigationTimingEntry = constructNavigationTimingContext(observedNavigationTiming);
                    }
                });
                perfObserver.observe({
                    type: 'navigation',
                    buffered: true,
                });
            }
        },
        contexts: function () { return navigationTimingEntry || getPerformanceNavigationTimingContext(); },
    };
}

export { PerformanceNavigationTimingPlugin };
//# sourceMappingURL=index.module.js.map
